import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class UpdateInstallemntsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerPaymentOperation/updateInstallment',
      requesterInfo,
    })
  }

  public async updateInstallemnts(request: any): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
